import React from "react";
import { Box, TextField } from "@mui/material";

const TurnoverTab = ({ data, onUpdate }) => {
  const updateField = (path, value) => {
    onUpdate(path, value);
  };

  return (
    <Box>
      {/* Turnover Conclusions */}
      <Box sx={{ marginBottom: "16px" }}>
        <Box sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: "#1A1E24",
          marginBottom: "8px"
        }}>
          Выводы о динамике оборотов, диверсификации, распределения среди банков:
        </Box>
        <TextField
          value={data.creditPolicy?.turnoverConclusions || ""}
          onChange={(e) => updateField("creditPolicy.turnoverConclusions", e.target.value)}
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              fontSize: "14px",
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default TurnoverTab;
